/* Loads product recommendations through the section rendering API. */
(function () {
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      var url = this.dataset.url;
      if (!url || this.dataset.loaded || this.querySelector('.jm-grid')) return;
      this.dataset.loaded = 'true';
      var self = this;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('product-recommendations');
          if (fresh && fresh.innerHTML.trim().length) {
            self.innerHTML = fresh.innerHTML;
            if (window.JM && JM.initReveal) JM.initReveal(self);
          } else {
            self.remove();
          }
        })
        .catch(function () { self.remove(); });
    }
  }
  if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);
})();
